const Kategoriya2323 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 3-chorak<br />
                Mavzu: Gapning asosi <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Kichik guruhlarda ishlang. Aralash so‘zlarni o‘qing va ma’noviy yaqinligiga ko‘ra guruhlarga ajrating.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z va uning ma’nosi haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p>Ayiq, qadam tashladi, bo‘ri, maktab, kuldi, yurdi, tirjaydi, muzey, chiyabo‘ri, ishshaydi, odimladi, etdi, tulki, uy, shiypon, iljaydi,do‘kon, gepard.</p>
            <p className="text-break">1-guruh: ________________________________________________</p>
            <p className="text-break">2-guruh: ________________________________________________</p>
            <p className="text-break">3-guruh: ________________________________________________</p>
            <p className="text-break">4-guruh: ________________________________________________</p>
            <p><b>2-mashq. Iboralar ishtirokida gaplar tuzing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning gap haqidagi ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Aqlini tanimoq - __________________________________________________</p>
            <p className="text-break">Esini yig‘moq - __________________________________________________</p>
            <p><b> 3-mashq. Berilgan matnni o‘qing va FDM usulidan foydalanib, fikrlar yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p><i>O‘zbek oilalarida ota-onani ulug‘ deydilar, hamma ularning hurmatini joyiga qo‘yadi. Lekin ba’zi insonlar ularni ranjitib, “oq padar” degan nomga sazovor bo‘ladilar. Bu esa bizning ma’naviyatimizdan yiroq narsa.</i></p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2323;